import { GetFinanceTradesHistoryApi } from "@/features/accounts/finance/services/get-trades-history-api";
import { GetFinanceTradesHistoryRequestModel } from "@/features/accounts/finance/services/get-trades-history-model";

/// 銀行取込履歴取得処理
export class GetFinanceTradesHistoryService {
  private getFinanceTradesHistoryApi = new GetFinanceTradesHistoryApi();

  /**
   * 銀行取込履歴取得API実行
   */
  public async getFinanceTradesHistory(param: GetFinanceTradesHistoryRequestModel) {
    return await this.getFinanceTradesHistoryApi.getFinanceTradesHistory(param);
  }
}
